import 'babel-polyfill';
import 'jquery';
import 'jquery-ui';
import 'jquery-ui/ui/effect';
import 'jquery-ui/ui/effects/effect-bounce';
import 'jquery-ui/themes/base/all.css';
import 'jquery-ui/ui/widgets/datepicker';
import 'jquery-ui/ui/widgets/autocomplete';
import 'jquery-ui/ui/widgets/tabs';
import 'jquery-ui/ui/widgets/tooltip';
import 'jquery-ui/ui/widgets/sortable';
import 'jquery-ui/ui/widgets/slider';
import 'jquery-ui-timepicker-addon/dist/jquery-ui-timepicker-addon.css';
import 'font-awesome/css/font-awesome.css';
import 'lodash';
import 'moment';
import 'moment-timezone';
import 'jquery.scrollto';
import 'jquery.cookie';
import 'jqmodal';
import '../../vendor/jqmodal-fix';
import 'jquery.iframe-transport';
import 'blueimp-file-upload';
import 'autonumeric';
import 'jquery-ui-timepicker-addon';
import 'showdown';
import 'react';
import 'react-dom';
import 'mobx';
import 'mobx-react';
import 'classnames';
import 'axios';
import 'tslib';
import 'signalr';
import 'prop-types';
import 'styled-components';

if (__DEV__) {
  require('react-hot-loader');
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/entry/vendor.ts